import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';

export const DEAL_SUMMARY_PDF_WORKFLOW_STATUSES: WorkflowStatus[] = [WorkflowStatus.DESKED, WorkflowStatus.ACCEPTED];
